module.exports = __webpack_public_path__ + "img/sms-calls.c2aabcb4.svg";